export default "__VITE_ASSET__5M55PnVh__"